export const environment = {
   production: true,
   cms: 'https://cms.gestisco.sciamlab.com',
};
